/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlBulkResolveClientResult } from './ControlBulkResolveClientResult';
import {
    ControlBulkResolveClientResultFromJSON,
    ControlBulkResolveClientResultFromJSONTyped,
    ControlBulkResolveClientResultToJSON,
} from './ControlBulkResolveClientResult';

/**
 * 
 * @export
 * @interface ControlBulkResolveZeroDayAlertResponse
 */
export interface ControlBulkResolveZeroDayAlertResponse {
    /**
     * 
     * @type {Array<ControlBulkResolveClientResult>}
     * @memberof ControlBulkResolveZeroDayAlertResponse
     */
    results: Array<ControlBulkResolveClientResult>;
}

/**
 * Check if a given object implements the ControlBulkResolveZeroDayAlertResponse interface.
 */
export function instanceOfControlBulkResolveZeroDayAlertResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function ControlBulkResolveZeroDayAlertResponseFromJSON(json: any): ControlBulkResolveZeroDayAlertResponse {
    return ControlBulkResolveZeroDayAlertResponseFromJSONTyped(json, false);
}

export function ControlBulkResolveZeroDayAlertResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlBulkResolveZeroDayAlertResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'results': ((json['results'] as Array<any>).map(ControlBulkResolveClientResultFromJSON)),
    };
}

export function ControlBulkResolveZeroDayAlertResponseToJSON(value?: ControlBulkResolveZeroDayAlertResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'results': ((value.results as Array<any>).map(ControlBulkResolveClientResultToJSON)),
    };
}

